import "./share.less";
import { isiOS, isHuawei, getUrlParams, isChrome } from "../../static/js/https";
const { createApp, ref, onMounted } = Vue;
createApp({
  setup() {
    onMounted(async () => {});

    const inviteCode = ref(getUrlParams().InviteCode);

    const isCopy_success = ref(false);
    const schemeURL = `halawaapp://halawa/?roomId=${inviteCode.value}`; //安卓和ios唤醒
    const iosSchemeURL = `https://www.halawateam.com/apple-app-site-association/account/chatRoom?roomId=${inviteCode.value}`;
    const intentURL = `intent://halawa/?roomId=${inviteCode.value}#Intent;scheme=halawaapp;package=com.vptrm.vcvroom;end`;
    const downloadURL =
      "https://play.google.com/store/apps/details?id=com.vptrm.vcvroom";
    // const universalLink = `https://www.yiyagroup.com/yiya/?roomId=${inviteCode.value}`;
    const universalLink = "https://apps.apple.com/cn/app/id6458732985";
    const iosUniversalLink = `https://www.halawateam.com/account/chatRoom?roomId=${inviteCode.value}`;
    const appleStoreLink = "https://apps.apple.com/cn/app/id6458732985";

    const copy = () => {
      if (inviteCode.value == "" || inviteCode.value == undefined) return;
      const textarea = document.createElement("textarea");
      textarea.value = inviteCode.value;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        isCopy_success.value = true;
        setInterval(() => {
          isCopy_success.value = false;
        }, 1500);
      } catch (err) {}
      document.body.removeChild(textarea);
    };
    function getEnv() {
      const ua = navigator.userAgent.toLowerCase();
      return {
        isIOS: /iphone|ipad|ipod/.test(ua),
        isAndroid: /android/.test(ua),

        // 主流手机品牌自带浏览器检测
        isMiBrowser: /miuibrowser/.test(ua), // 小米
        isHuaweiBrowser: /huawei|honor/.test(ua) && /version\/\d+/.test(ua), // 华为/荣耀
        isOppoBrowser: /heytap|oppo/.test(ua) && /browser/.test(ua), // OPPO/realme/一加
        isVivoBrowser: /vivo/.test(ua) && /browser/.test(ua), // vivo/iQOO
        isSamsungBrowser: /samsungbrowser/.test(ua), // 三星
        isUcBrowser: /ucbrowser|ucweb/.test(ua), // UC浏览器
        isQuark: /quark/.test(ua), // 夸克
        isSogouBrowser: /sogou/.test(ua), // 搜狗
        isBaiduBrowser: /baidubrowser/.test(ua), // 百度
        is360Browser: /360browser|qihoo/.test(ua), // 360

        // 社交/办公应用内嵌浏览器检测
        isWechat: /micromessenger/.test(ua),
        isQQ: /\sqq\//.test(ua),
        isWeibo: /weibo/.test(ua),
        isFeishu: /lark/.test(ua) || ua.includes("feishu"),
        isMiniProgram: ua.includes("miniprogram"),
        isDingTalk: /dingtalk/.test(ua),

        // 标准浏览器检测
        isChrome:
          /chrome/.test(ua) &&
          !/edg/.test(ua) &&
          !/miuibrowser|huawei|honor|heytap|oppo|vivo|samsungbrowser|ucbrowser|ucweb|quark|sogou|baidubrowser|360browser|qihoo/.test(
            ua
          ),
        isFirefox: /firefox/.test(ua),
        isEdge: /edg/.test(ua),
        isSafari: /safari/.test(ua) && !/chrome/.test(ua),

        // WebView环境判断
        isWebView:
          /(micromessenger|weibo|qq\/|line|lark|feishu|whatsapp|dingtalk)/.test(
            ua
          ),

        // 其他特征
        isStandalone: window.navigator.standalone,
        isInAppBrowser: !/^http/.test(window.location.protocol),
      };
    }
    function download(isUserAction = true) {
      const env = getEnv();
      const startTime = Date.now();
      // 在社交/办公应用内且非用户主动点击时，显示提示
      if (env.isWebView && !isUserAction) {
        document.getElementById("notice").style.display = "block";
        document.getElementById("openBtn").style.display = "inline-block";
        return;
      }

      if (env.isIOS) {
        // iOS处理逻辑
        console.log("isIOS", schemeURL, document.visibilityState);
        window.location.href = schemeURL;

        setTimeout(() => {
          if (Date.now() - startTime < 2500) {
            console.log("isIOS2", appleStoreLink, document.visibilityState);
            // document.addEventListener("visibilitychange", function () {
            //   if (document.visibilityState === "hidden") {
            //     console.log("页面已进入后台");
            //   } else {
            //     console.log("页面已恢复可见");
            //   }
            // });
            if (document.visibilityState === 'visible') {
              console.log("页面已进入后台");
              window.location.href = appleStoreLink;
            }
          }
        }, 2000);
      } else if (env.isAndroid) {
        // Android处理逻辑
        if (env.isChrome && !env.isWebView) {
          // 标准Chrome浏览器使用Intent
          window.location.href = intentURL;
        } else if (
          env.isMiBrowser ||
          env.isHuaweiBrowser ||
          env.isOppoBrowser ||
          env.isVivoBrowser ||
          env.isSamsungBrowser ||
          env.isUcBrowser ||
          env.isQuark ||
          env.isSogouBrowser ||
          env.isBaiduBrowser ||
          env.is360Browser
        ) {
          // 各品牌自带浏览器优先使用Scheme
          window.location.href = schemeURL;
        } else {
          // 其他Android浏览器fallback
          window.location.href = schemeURL;
        }

        // 统一设置超时跳转
        setTimeout(() => {
          if (Date.now() - startTime < 2000) {
            window.location.href = downloadURL;
          }
        }, 1500);
      } else {
        // 其他平台直接跳转下载页
        window.location.href = downloadURL;
      }
    }
    /**  */
    // const download = () => {
    //   if (inviteCode.value == "" || inviteCode.value == undefined) return;
    //   console.log("isChrome", isChrome, navigator.userAgent);
    //   if (isChrome) {
    //     const schemeUrl =
    //       "https://www.yiyagroup.com/yiya/?roomId=" + inviteCode.value;
    //     console.log("schemeUrl", schemeUrl);
    //     window.location.href = schemeUrl;
    //   }
    //   if (isiOS) {
    //     window.location.href = "https://apps.apple.com/cn/app/id6458732985";
    //     // https://apps.apple.com/cn/app/id6458732985
    //   } else if (isHuawei) {
    //     setTimeout(() => {
    //       window.location.href = "appmarket://details?id=com.vptrm.vcvroom";
    //     }, 500);
    //     // https://play.google.com/store/apps/details?id=com.vptrm.vcvroom
    //   } else {
    //     setTimeout(() => {
    //       window.location.href =
    //         "https://play.google.com/store/apps/details?id=com.vptrm.vcvroom";
    //     }, 500);
    //     // https://play.google.com/store/apps/details?id=com.vptrm.vcvroom
    //   }
    // };
    return {
      download,
      copy,
      inviteCode,
      isCopy_success,
    };
  },
}).mount("#app");
